import React, { useState, useEffect } from 'react';

import TextField from '@mui/material/TextField';

import Button from '@mui/material/Button';

import PersonIcon from '@mui/icons-material/Person';
import InputAdornment from '@mui/material/InputAdornment';

import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import EventIcon from '@mui/icons-material/Event';
import { Autocomplete, Grid } from '@mui/material';
import axios from 'axios';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import addCommas from '../../utils/functions/commas';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import dayjs from 'dayjs';
import { subMonths, startOfMonth, format } from 'date-fns';
import * as XLSX from 'xlsx';
import { useReportMatchQuery } from '../../services/reportMatch';
import checkAccessRights from '../../utils/functions/accessRight';
import { ROLES } from '../../utils/constants';
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

function ReportMatch() {
  const { t } = useTranslation();
  const [searchTotal, setSearchTotal] = useState('');
  const [searchCustomer, setSearchCustomer] = useState('');
  const [searchBankName, setSearchBankName] = useState('');
  const [total, setTotal] = useState(10);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortBy, setSortBy] = useState('statement_date');
  const [sortOrder, setSortOrder] = useState('desc');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectStatus, setSelectStatus] = useState('');
  const [selectBank, setSelectBank] = useState(null);
  const [groupBank, setGroupBank] = useState([]);
  const { value: merchant, allMerchant } = useSelector(
    (state) => state.merchant,
  );
  const isAdminRole = checkAccessRights(ROLES.ADMIN_ROLE);
  const sorgcode = isAdminRole ? merchant || '' : allMerchant || '';

  const {
    data: matchReportData,
    isLoading,
    refetch,
    isFetching,
  } = useReportMatchQuery(
    {
      sorgcode,
      bankName: searchBankName,
      amount: searchTotal,
      page: page === 0 ? 1 : page + 1,
      size: rowsPerPage,
      statementDateFrom: startDate,
      statementDateTo: endDate,
      search: searchCustomer,
      sortBy,
      sortOrder,
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  useEffect(() => {
    // คำนวณวันที่ 1 ของเดือนก่อนหน้า
    const firstDayOfLastMonth = startOfMonth(subMonths(new Date(), 1));
    // แปลงวันที่ให้เป็นรูปแบบ yyyy-MM-dd
    const formattedStartDate = format(firstDayOfLastMonth, 'yyyy-MM-dd');
    setStartDate(formattedStartDate);

    // เซ็ตวันที่ปัจจุบัน
    const today = format(new Date(), 'yyyy-MM-dd');
    setEndDate(today);
  }, []);

  const handleTotal = (event) => {
    setSearchTotal(event.target.value);
  };
  const handleSearchCustomer = (event) => {
    setSearchCustomer(event.target.value);
  };

  const handleStatusCheckBox = (event) => {
    if (event.target.value) {
      setSelectStatus(event.target.value);
    } else {
      setSelectStatus('');
    }
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (property) => {
    const isAsc = sortBy === property && sortOrder === 'asc';

    setSortOrder(isAsc ? 'desc' : 'asc');
    setSortBy(property);
    setPage(0);
  };

  useEffect(() => {
    setTotal(matchReportData?.total || 0);
  }, [matchReportData]);

  useEffect(() => {
    const fetchGroupBank = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL_admin}/matchstatement/group-bank-acc`,
        );
        const dataGroupBank = response?.data.data;

        setGroupBank(dataGroupBank); // เปลี่ยน responseData เป็น data
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchGroupBank();

    return () => {
      //
    };
  }, []);

  const customCellHeader = {
    whiteSpace: 'nowrap',
    backgroundColor: 'primary.main',
    color: 'white',
    padding: '14px',
  };
  const sortLabelSx = {
    color: 'white !important',
    '& .MuiTableSortLabel-icon': {
      color: 'white !important',
    },
  };
  const customCellData = {
    whiteSpace: 'nowrap',
    fontSize: '13px',
  };

  const handleExport = () => {
    const ws = XLSX.utils.json_to_sheet(matchReportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'ReportMatch');
    XLSX.writeFile(wb, 'ReportMatch.xlsx');
  };

  return (
    <div>
      <div className="flex flex-col gap-4 p-4">
        <div className="font-bold text-lg">{t('app.reportMatchedTitle')}</div>

        <div className="rounded-lg border-2 border-gray-300 p-4">
          <div className="flex flex-col md:flex-row md:flex-wrap md:items-end gap-4">
            <div className="w-full md:basis-2/12">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t('app.bookbookbankNo')}
              </label>
              <Autocomplete
                value={selectBank}
                options={groupBank}
                getOptionLabel={(option) =>
                  `${option.bank_name}-${option.account_no}`
                }
                onChange={(event, newValue) => {
                  setSelectBank(newValue);
                  setSearchBankName(
                    newValue
                      ? `${newValue.bank_name}-${newValue.account_no}`
                      : '',
                  );
                }}
                disablePortal
                size="small"
                id="combo-box-demo"
                sx={{ width: '100%' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={t('app.selectBankAccount')}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountBalanceIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </div>

            <div className="w-full md:basis-2/12">
              <label className="block text-sm font-medium text-gray-700 mb-1">
               {t('app.totalMatch')}
              </label>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MonetizationOnIcon />
                    </InputAdornment>
                  ),
                }}
                type="text"
                placeholder={t('app.thb')}
                size="small"
                sx={{ width: '100%', backgroundColor: '#FFFFFF' }}
                value={searchTotal}
                onChange={handleTotal}
              />
            </div>

            <div className="w-full md:basis-2/12">
              <label className="block text-sm font-medium text-gray-700 mb-1">
               {t('app.depositDate')}
              </label>
              <TextField
                type="date"
                variant="outlined"
                sx={{ width: '100%' }}
                size="small"
                value={startDate}
                onChange={handleStartDateChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* --- To (2/12) --- */}
            <div className="w-full md:basis-2/12">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                  {t('app.toDate')}
              </label>
              <TextField
                type="date"
                variant="outlined"
                sx={{ width: '100%' }}
                size="small"
                value={endDate}
                onChange={handleEndDateChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* --- Customer No. (3/12) --- */}
            <div className="w-full md:basis-3/12">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t('navbar.custNo')}
              </label>
              <TextField
                value={searchCustomer}
                onChange={handleSearchCustomer}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                }}
                type="text"
                placeholder="Search Customer Name / Tax ID"
                size="small"
                sx={{ backgroundColor: '#FFFFFF', width: '100%' }}
              />
            </div>

            <div className=" w-full md:w-auto md:basis-1/12">
              <Button
                variant="contained"
                sx={{ color: 'white', width: '100%' }}
                onClick={handleExport}
              >
                <FileDownloadIcon />  {t('app.export')}
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-5 border-gray-200 md:border-2 ">
          <div>
            <TableContainer sx={{ maxHeight: 400 }}>
              <Table stickyHeader aria-label="simple table ">
                <TableHead>
                  <TableRow>
                    {/* ... TableCells ... */}
                    <TableCell align="center" sx={customCellHeader}>
                      <TableSortLabel
                        active={sortBy === 'book_bank_no'}
                        direction={sortBy === 'book_bank_no' ? sortOrder : 'asc'}
                        onClick={() => handleRequestSort('book_bank_no')}
                        sx={sortLabelSx}
                      >
                        {t('app.bookbankNoStatment')}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="center" sx={customCellHeader}>
                      <TableSortLabel
                        active={sortBy === 'statement_date'}
                        direction={sortBy === 'statement_date' ? sortOrder : 'asc'}
                        onClick={() => handleRequestSort('statement_date')}
                        sx={sortLabelSx}
                      >
                        {t('app.dateTime')}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="center" sx={customCellHeader}>
                      <TableSortLabel
                        active={sortBy === 'amount_from_erp'}
                        direction={sortBy === 'amount_from_erp' ? sortOrder : 'asc'}
                        onClick={() => handleRequestSort('amount_from_erp')}
                        sx={sortLabelSx}
                      >
                        {t('app.amountMoneyThb')}
                      </TableSortLabel>
                    </TableCell>
                    {/* (ใส่คอลัมน์ที่เหลือของคุณที่นี่) */}
                    <TableCell align="center" sx={customCellHeader}>
                      <TableSortLabel
                        active={sortBy === 'receipt_no'}
                        direction={sortBy === 'receipt_no' ? sortOrder : 'asc'}
                        onClick={() => handleRequestSort('receipt_no')}
                        sx={sortLabelSx}
                      >
                        {t('app.documentRC03No')}
                      </TableSortLabel>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {isFetching ? (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  ) : _.size(matchReportData?.data) ? (
                    matchReportData?.data?.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell align="center" sx={customCellData}>
                          <div className="text-green-600 font-bold">
                            {row.book_bank_no}
                          </div>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            align: 'center',
                            fontSize: '13px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {dayjs(row.statement_date).format('DD MMMM YYYY')}
                        </TableCell>
                        <TableCell align="center" sx={customCellData}>
                          {addCommas(row.amount_from_erp)}
                        </TableCell>
                        {/* (ใส่คอลัมน์ที่เหลือของคุณที่นี่) */}
                        <TableCell align="center" sx={customCellData}>
                          {row.receipt_no}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        <div> {t('app.noDataAvailable')}</div>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 25, 100]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportMatch;
